import i18next from 'i18next'
import React from 'react'
import { Form } from 'react-bootstrap'
import { DataLayer } from '../../utils/datalayer'
import { Alphabetized } from '../azNavigation/azNavigationUtils'
import { useDebounce } from '../hooks/useDebounce'
import { EmptyLayout } from '../sharedLayout/empty'
import { FormControls } from '../sharedLayout/forms'
import { NavigationSection } from '../sharedLayout/navigationSection'

export type FolderProps = {
  kind: 'page' | 'pdf'
  title: string
  introduction?: string
  url: string
  afdeling?: string
  index?: number
}

export const FoldersLayout = (props: {
  folders?: Alphabetized<FolderProps>
}) => (
  <>
    <section className="sections sections--pagination sections--folders container--m gutter--m">
      {props.folders && props.folders?.length > 0 ? (
        props.folders.map((folderGroup) => (
          <NavigationSection kind="folder" letter={folderGroup.letter} folders={folderGroup.items} />
        ))
      ) : (
        <EmptyLayout
          hasWrapper={false}
          text={i18next.t('a11y:noEntityFound', {
            entity: i18next.t('misc:folders_plural').toLowerCase(),
          })}
        />
      )}
    </section>
  </>
)

export const FoldersFiltering = (props: {
  departmentOrCentrumList: string[]
  search: { searchInput?: string; changeSearchInput: (searchInput?: string) => void }
  filter: { selectedFilter?: string; changeSelectedFilter: (filter?: string) => void }
  resultCount: number
}) => {
  const { search, filter, departmentOrCentrumList, resultCount } = props
  const lastTrackedSearch = React.useRef<Set<string>>(new Set())

  useDebounce(search.searchInput, 800, (value) => {
    const normalizedValue = (value ?? '').toLowerCase().trim()

    if (normalizedValue.length > 2 && !lastTrackedSearch.current.has(normalizedValue)) {
      lastTrackedSearch.current.add(normalizedValue)
      DataLayer.folderFilterEvent('search_filter', normalizedValue, resultCount)
    }
  })

  return (
    <div className="block__inner container--m gutter--m">
      <Form.Group>
        <div className="filterbar">
          <div className="filterbar__selector">
            <FormControls.FormSelectInGroup
              key="select"
              controlId="select"
              label="Afdeling of centrum"
              required={true}
              onChange={(newValue) => {
                const normalized = newValue.toLowerCase().trim()
                filter.changeSelectedFilter(normalized)
                DataLayer.folderFilterEvent('afdeling_filter', normalized, resultCount)
              }}
              value={filter.selectedFilter}
            >
              <option key="default" value="">
                Selecteer een afdeling of centrum
              </option>
              <>
                {departmentOrCentrumList.map((dc, index) => (
                  <option key={index} value={dc.toLowerCase().trim()}>
                    {dc}
                  </option>
                ))}
              </>
            </FormControls.FormSelectInGroup>
          </div>

          <div className="filterbar__input">
            <FormControls.FormItemInGroup
              controlId="input"
              label="Zoek op onderwerp"
              type="text"
              value={search.searchInput}
              required={true}
              onChange={(newValue) => {
                search.changeSearchInput(newValue)
              }}
              placeholder="Zoeken"
            />
            <svg className="filterbar__icon" width="24px" height="24px">
              <use xlinkHref="#icon--SG-search-outlined" />
            </svg>
          </div>
        </div>
      </Form.Group>
    </div>
  )
}
